import { fileAccessLogConstants } from "_constants";
import { REHYDRATE } from "redux-persist/lib/constants";
import { produce } from "immer";

let initState = {
  logs: [],
  loading: false,
  error: null,
};

export function fileAccessLog(state = { ...initState }, action) {
  const { payload, type } = action;
  switch (type) {
    case fileAccessLogConstants.GET_FILE_ACCESS_LOG_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.error = null;
      });

    case fileAccessLogConstants.GET_FILE_ACCESS_LOG_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.error = null;
        draft.logs = [...payload];
      });

    case fileAccessLogConstants.GET_FILE_ACCESS_LOG_FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.error = payload;
        draft.logs = [];
      });

    case fileAccessLogConstants.CLEAR_FILE_ACCESS_LOG:
      return { ...initState };

    case REHYDRATE: {
      if (payload && payload.admin && payload.admin.fileAccessLog) {
        return { ...payload.admin.fileAccessLog };
      } else {
        return { ...initState };
      }
    }

    default:
      return state;
  }
}
